/**
 *
 * Provides fake storage over AWS Storage (Amplify v6)
 */

import type {
  DownloadDataWithPathInput,
  DownloadDataWithPathOutput,
  GetUrlWithPathInput,
  GetUrlWithPathOutput,
  UploadDataWithPathInput,
  UploadDataWithPathOutput,
} from 'aws-amplify/storage';
import { delayedResolve, delayedReject } from './FakeAuth';
import avatar from './assets/avatar';

const Storage = {
  getUrl: async ({
    path,
    options,
  }: GetUrlWithPathInput): Promise<GetUrlWithPathOutput> => {
    const url = avatar;

    if (path) {
      const expiresAt = new Date(
        Date.now() + (options?.expiresIn || 3600) * 1000,
      );
      return delayedResolve({
        url: new URL(url),
        expiresAt,
      });
    } else {
      return delayedReject({
        name: 'InvalidParameterException',
        message: 'Path is required',
      });
    }
  },

  downloadData: async ({
    path,
    options,
  }: DownloadDataWithPathInput): Promise<DownloadDataWithPathOutput> => {
    const url = options ? avatar : avatar;

    if (path) {
      return delayedResolve({
        url: new URL(url),
        body: {
          text: async () => 'fake-file-content',
          json: async () => ({ fake: 'data' }),
          blob: async () => new Blob(['fake-content'], { type: 'text/plain' }),
        },
      });
    } else {
      return delayedReject({
        name: 'InvalidParameterException',
        message: 'Path is required',
      });
    }
  },

  uploadData: async ({
    path,
    data,
    options,
  }: UploadDataWithPathInput): Promise<UploadDataWithPathOutput> => {
    const processedData = data;

    if (path && processedData) {
      if (options?.onProgress) {
        setTimeout(
          () => options.onProgress?.({ transferredBytes: 50, totalBytes: 100 }),
          100,
        );
        setTimeout(
          () =>
            options.onProgress?.({ transferredBytes: 100, totalBytes: 100 }),
          200,
        );
      }

      return delayedResolve({
        result: {
          path,
          eTag: 'fake-etag-123',
          size: 1024,
          lastModified: new Date(),
        },
      });
    } else {
      return delayedReject({
        name: 'InvalidParameterException',
        message: 'Path and data are required',
      });
    }
  },
};

export default Storage;
